import { GenericBackgroundImage } from 'takeovers/utils/components/GenericBackgroundImage'
import { rem } from 'polished'
import useResponsiveSelector from 'hooks/useResponsiveSelector'

interface Props {
  className?: string
  background?: App.SiteTakeoverBackground
  imageId?: string
  placement?: App.SiteTakeoverPlacement
}

function MaldivesCharterTakeoverBackground(props: Props) {
  const { className, imageId } = props
  const backgroundStyle = useResponsiveSelector({
    mobile: '#1776EB',
    tablet: '#1776EB',
  }) ?? 'linear-gradient(90deg, #1776EB 0%, #52DBE8 99.04%)'

  return (
    <GenericBackgroundImage
      className={className}
      imageId={imageId || 'maldives-gradient-bg'}
      backgroundStyle={backgroundStyle}
      attachments={[
        {
          imageId: 'maldives-big-left-palm-tree',
          left: rem(24),
          bottom: rem(-224),
          min: 'desktop',
        },
        {
          imageId: 'maldives-right-palm-tree',
          right: rem(160),
          bottom: rem(-168),
          min: 'desktop',
        },
      ]}
    />
  )
}

export default MaldivesCharterTakeoverBackground
